/** @prettier */
import { Record } from 'immutable';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Tabs from '@xanadu/ui-shared/components/widgets/Tabs';

import ActiveView from '../../containers/Multiples/ActiveView';
import BuildView from '../../containers/Multiples/BuildView';

import Unavailable from '../common/Unavailable';

import style from './Multiples.module.scss';

const Multiples = ({ multipleBuild, available, buildSubmitted, setMultiplesTab }) => {
  const [activeTab, setActiveTab] = useState('build');

  useEffect(() => {
    const selections = multipleBuild.get('selections');

    if (selections.size === 0 && buildSubmitted) {
      setActiveTab('active');
      setMultiplesTab({ activeTab: 'active' });
    } else {
      setActiveTab('build');
      setMultiplesTab({ activeTab: 'build' });
    }
  }, [multipleBuild, buildSubmitted, setMultiplesTab]);

  const updateTabActive = (newTab) => {
    setActiveTab(newTab);
    setMultiplesTab({ activeTab: newTab });
  };

  const tabs = [
    {
      label: 'Build',
      value: 'build',
      dataHook: 'multiples-build',
      className: style.tab,
      onClick: () => updateTabActive('build'),
    },
    {
      label: 'Active',
      value: 'active',
      dataHook: 'multiples-active',
      className: style.tab,
      onClick: () => updateTabActive('active'),
    },
  ];

  const getContent = () => {
    switch (activeTab) {
      case 'build':
        return <BuildView />;
      case 'active':
        return <ActiveView />;
      default:
        return <div />;
    }
  };

  const content = getContent();

  return (
    <div className={style.multiples}>
      <Tabs value={activeTab} theme="dark" className={style.tabs} tabs={tabs} />
      {available ? (
        <div className={style.content}>{content}</div>
      ) : (
        <Unavailable>
          <span>Multiples are not available at present.</span>
          <span>Our technical team are aware of this and are currently working on this.</span>
        </Unavailable>
      )}
    </div>
  );
};

Multiples.propTypes = {
  multipleBuild: PropTypes.instanceOf(Record).isRequired,
  available: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  buildSubmitted: PropTypes.bool.isRequired,
  setMultiplesTab: PropTypes.func.isRequired,
};

export default Multiples;
